var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleStarEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8655 0.00855437C11.9168 0.00296323 11.9684 0.000113721 12.02 0C12.6233 0.00386358 13.1622 0.378767 13.3766 0.943756L15.7835 7.33906L22.5979 7.66124C23.9518 7.71845 24.5055 9.4313 23.4421 10.273L18.1217 14.5612L19.9191 21.1532C20.2618 22.4489 18.831 23.4866 17.7096 22.7556L12.0086 19.0091L6.29324 22.7556C5.17131 23.4915 3.7353 22.4514 4.08094 21.1532L5.87825 14.5612L0.557856 10.273C-0.505532 9.4313 0.0481774 7.71844 1.40214 7.66124L8.21648 7.33906L10.6434 0.943756C10.8409 0.425121 11.3141 0.0629782 11.8655 0.00855437Z",
    fill: "#E6E6E9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleStarEmpty);
export default __webpack_public_path__ + "static/media/google-star-empty.65499f3995afe40fc0b77a7941f122b1.svg";
export { ForwardRef as ReactComponent };